import { Button } from '@/components/ui/button';
import { useLocale } from '@/lib/hooks/use-locale';
import { cn } from '@/lib/utils';
import { SearchIcon } from 'lucide-react';
import type { PropsWithChildren } from 'react';
import { isMacOs } from 'react-device-detect';
import { useGlobalSearch } from './global-search-bar-provider';

interface Props extends PropsWithChildren {
    showFullInput?: boolean;
    showShortcutKey?: boolean;
    className?: string;
}

const GlobalSearchBar: React.FC<Props> = ({
    showFullInput = true,
    showShortcutKey = true,
    className = '',
}) => {
    const { t } = useLocale();

    const { openSearch, open } = useGlobalSearch();

    const shortcutKey = isMacOs ? '⌘ K' : 'Ctrl K';

    return (
        <div className={cn(showFullInput ? 'w-full' : '', className)}>
            {showFullInput ? (
                <Button
                    className="w-full bg-white border"
                    variant="ghost"
                    selected={open}
                    onClick={() => openSearch()}
                >
                    <SearchIcon className="h-4 w-4" />
                    <span className="mr-auto">{t('search')}</span>
                    {showShortcutKey && <span className="rounded-md border px-1">{shortcutKey}</span>}
                </Button>
            ) : (
                <Button
                    size={showFullInput ? undefined : 'icon-s'}
                    variant="ghost"
                    selected={open}
                    onClick={() => openSearch()}
                >
                    <SearchIcon className="flex h-4 w-4 shrink-0" />
                </Button>
            )}
        </div>
    );
};

export { GlobalSearchBar };
